<template>
  <div class="p-4">
    <div class="-content d-flex align-items-start flex-column">
      <div class="page-global-header px-0">
        <div class="row justify-content-end mx-0">
          <div
            class="col-sm-12 col-md-12 col-lg-6 col-xl-5 col-xxl-5 d-flex justify-content-end"
          >
            <button class="btn btn-white" style="cursor: default;" type="button">Expense No: {{ form.expense_no }}</button>
          </div>
        </div>
      </div>

      <div class="page-body">
        <div class="row mx-0">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-5">
            <form class="base-form" style="padding-left: 80px;">
              <div class="row m-0 mb-3">
                <div class="input-group _group-xl p-0">
                  <span class="input-group-text bg-bostonBlue flush-after label-w-fixed">
                    Payment Method
                    <span class="required">*</span>
                  </span>
                  <select v-model="form.payment_type" required class="form-select">
                    <option disabled selected value="">Payment Method*</option>
                    <option
                      v-for="option in payment_method"
                      :value="option"
                      :key="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row m-0 mb-3">
                <div class="input-group _group-xl p-0">
                  <span class="input-group-text bg-bostonBlue flush-after label-w-fixed">
                    Expense Date
                  </span>
                  <input
                    type="date"
                    name="datepick"
                    class="form-control datepicker text-end text-black _3d-input chevron-circle"
                    v-model="form.expense_date"
                    onfocus="this.showPicker()"
                    data-date-format="mm/dd/yyyy"
                  />
                </div>
              </div>

              <div class="row m-0 mb-3">
                <div class="input-group _group-xl p-0">
                  <span class="input-group-text bg-bostonBlue flush-after label-w-fixed">
                    Currency
                  </span>
                  <select
                    v-model="form.currency_id"
                    required
                    class="form-select"
                    @change="changeCurrency"
                  >
                    <option disabled selected value="">Currency*</option>
                    <option
                      v-for="option in currencyOptions"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }} ({{ option.symbol }})
                    </option>
                  </select>
                  <!-- <select name="currency" class="form-select" required>
                                        <option value="" selected disabled>Please Select</option>
                                        <option value="">British Pound</option>
                                        <option value="">American Dollar</option>
                                        <option value="">Euro</option>
                                    </select> -->
                </div>
              </div>

              <div class="row m-0 mb-3 mt-5" style="width: 110%;">
                <div class="input-group _group-xl p-0">
                  <select v-model="form.category_id" required class="form-select">
                    <option disabled selected value="">Expense category*</option>
                    <option
                      v-for="option in expenseCategoryServer"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row m-0 mb-3" style="width: 110%;">
                <div class="input-group _group-xl p-0">
                  <input
                    type="text"
                    name="vendorName"
                    class="form-control"
                    placeholder="Name of the Vendor (Optional)"
                    v-model="form.vendor"
                  />
                </div>
              </div>

              <div class="row m-0 mb-4" style="width: 110%;">
                <div class="input-group _group-xl h-auto p-0">
                  <textarea
                    name="notes"
                    class="form-control textarea-lg no-resize"
                    placeholder="Notes..."
                    v-model="form.notes"
                  ></textarea>
                </div>
                <span class="form-text text-end text-stamp">Max 255 character</span>
              </div>

              <div class="row m-0 mb-3 mt-5 d-flex justify-content-end" style="width: 110%;">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="input-group input-group--3d group-half p-0">
                      <div class="input-group-text bg-orange no-after">
                        Amount Paid
                        <span class="required text-danger">*</span>
                      </div>
                      <div class="form-floating">
                        <label class="floating-label">{{ currency_symbol }}</label>
                        <input
                          class="form-control text-right"
                          type="text"
                          inputmode="decimal"
                          v-model="form.amount"
                          v-numeric
                          placeholder="10,000.00"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 mx-auto">
            <div class="mb-2">
              <el-carousel :interval="4000" v-if="image_list.length > 0" :key="'old_'+image_list.length" arrow="always">
                <el-carousel-item
                  v-for="(image_file_old, key_old) in image_list"
                  :key="'image_list_old_' + key_old"
                  style="position: relative;"
                >
                  <img class="preview" :src="image_file_old" @click="openPreview(image_file_old, key_old)" style="cursor: pointer;" />
                  <button
                    type="button"
                    class="btn btn-danger btn-sm position-absolute"
                    style="bottom: 15px; right: 15px; z-index: 10; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"
                    @click.stop="deleteAttachment(image_list_names[key_old])"
                  >
                    <i class="fa fa-trash-alt"></i>
                  </button>
                </el-carousel-item>
              </el-carousel>

              <div class="row" v-if="image_list.length > 0">
                <div class="col-sm-12 d-flex align-items-center justify-content-center">
                  <h6>Preview ({{ image_list.length }})</h6>
                </div>
              </div>

              <!-- Vue Easy Lightbox -->
              <vue-easy-lightbox
                :visible="lightboxVisible"
                :imgs="[currentImage]"
                :index="0"
                @hide="lightboxVisible = false"
              >
                <template v-slot:toolbar="{ toolbarMethods }">
                  <div class="toolbar-buttons">
                    <!-- Zoom In -->
                    <button @click="toolbarMethods.zoomIn">
                      <i class="fas fa-search-plus"></i>
                    </button>
                    <!-- Zoom Out -->
                    <button @click="toolbarMethods.zoomOut">
                      <i class="fas fa-search-minus"></i>
                    </button>
                    <!-- Rotate Left -->
                    <button @click="toolbarMethods.rotateLeft">
                      <i class="fas fa-undo"></i>
                    </button>
                    <!-- Rotate Right -->
                    <button @click="toolbarMethods.rotateRight">
                      <i class="fas fa-undo rotate-right"></i>
                    </button>
                    <!-- Delete Button -->
                    <el-button
                      type="danger"
                      @click="deleteAttachment(currentImageKey)"
                      circle
                    >
                      <i class="fas fa-trash"></i>
                    </el-button>
                  </div>
                </template>
              </vue-easy-lightbox>
            </div>

            <el-carousel :interval="4000" v-if="image_list_edit.length > 0" :key="image_list_edit.length" arrow="always">
              <el-carousel-item
                v-for="(image, index) in image_list_edit"
                :key="'image_list_edit' + index"
                style="position: relative;"
              >
                <img class="preview" :src="image.preview" />
                <button
                  type="button"
                  class="btn btn-danger btn-sm position-absolute"
                  style="bottom: 15px; right: 15px; z-index: 10; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"
                  @click="removeNewImage(index)"
                >
                  <i class="fa fa-trash-alt"></i>
                </button>
              </el-carousel-item>
            </el-carousel>

            <div class="row" v-if="image_list_edit.length > 0">
              <div class="col-sm-12 d-flex align-items-center justify-content-center">
                <h6>Preview</h6>
              </div>
            </div>

            <div class="row attachment-row" v-if="image_list.length === 0 && image_list_edit.length === 0">
              <div class="col-sm-12 d-flex align-items-center justify-content-center">
                <div class="custome-fileupload-circle">
                  <input
                    type="file"
                    class="file-input expense-file"
                    accept="image/jpeg, image/png"
                    @change="onFileChange"
                    :max-size="512 * 1024"
                  />
                  <div class="file-content">
                    <div class="file-icon">
                      <i class="fa fa-camera"></i>
                    </div>
                    <div class="file-info-text">Add Attachment</div>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-12 d-flex align-items-center justify-content-center mt-2"
              >
                <small>Note: Max 1 image, size: 512kb, png or jpeg only.</small>
              </div>
            </div>

            <div class="row action-buttons-row">
              <div class="col-sm-12 d-flex align-items-center justify-content-between" style="gap: 1rem;">
                <a href="/list-expenses" class="btn btn-default btn-shadow">Cancel</a>
                <button class="btn btn-success btn-shadow" @click="saveData">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--file-upload-preview messaging modal-->
    <div
      class="modal fade mdl-messaging _info"
      id="uploadPreview"
      aria-hidden="true"
      aria-labelledby="uploadPreviewLabel"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-dialog-header">
          <div class="header-title">Preview</div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="upload-preview-frame">
              <div class="frame-header">
                <div class="col-auto"></div>
                <div class="col-auto">
                  <button
                    class="btn btn-transparent btn-sm btn-delet"
                    @click="deleteAttachment(image_list_names[key_old])"
                  >
                    <i class="fa fa-trash-alt"></i>
                  </button>
                </div>
              </div>

              <div class="frame-body">
                <div class="preview-screen">
                  <a
                    href="#"
                    class="preview-img"
                    data-bs-toggle="modal"
                    data-bs-target="#zoopPreview"
                    data-bs-dismiss="modal"
                    ><img :src="preview_image" />
                  </a>
                </div>
              </div>
            </div>

            <div class="upload-preview-thumb mt-4">
              <div
                class="thumb-item"
                v-for="(image_file_old, key_old) in image_list"
                :key="key_old"
              >
                <a href="#" class="thumb-image" @click="selectImage(image_file_old)">
                  <img :src="image_file_old"
                /></a>
                <span class="badge-count">1</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CURRENCY_LIST } from "../../config/url";
import moment from "moment";

export default {
  name: "EditExpenseComponent",

  data() {
    return {
      loadingInstance: null,
      currency: null,
      payment_method: null,
      expense_category: null,
      form: {
        amount: "",
        expense_id: "",
        expense_no: "",
        payment_type: "",
        expense_date: "",
        category_id: "",
        vendor: "",
        notes: "",
        currency_id: "",
        image: [],
        is_image: "N",
      },
      image_list: [],
      image_list_edit: [],
      image_list_names: [],
      expense_data_state: {},
      image_url: [],
      image_count: 0,
      currency_symbol: "",
      preview_image: "",
      currentImage: "",
      currentImageKey: "",
      lightboxVisible: false,
    };
  },
  created() {
    this.runMountedFunctions();
  },
  computed: {
    currencyOptions() {
      if (this.currency) {
        return this.currency.map((v) => {
          return {
            id: v.id,
            name: v.name,
            symbol: v.symbol,
          };
        });
      }
      return [];
    },
    expenseCategoryServer() {
      if (this.expense_category) {
        return this.expense_category.map((v) => {
          return {
            id: v.id,
            name: v.name,
          };
        });
      }
      return [];
    },
  },
  methods: {
    runMountedFunctions() {
      this.fetchCurrency();
      this.fetchPaymentMethod();
      this.expenseCategory();
      this.$nextTick(() => {
        this.editDataPopulate(this.$route.params.id);
      });
    },
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    selectImage(imageLink) {
      this.preview_image = imageLink;
    },
    openPreview(image, key) {
      this.currentImage = image;
      this.currentImageKey = this.image_list_names[key];
      this.lightboxVisible = true;
    },
    saveData() {
      if (this.form.payment_type == "") {
        this.$toast.error("Payment method is required.");
        return;
      }

      if (this.form.category_id == "") {
        this.$toast.error("Expense category is required.");
        return;
      }

      // The field is a text input now, so compare the parsed value instead of
      // matching the "0.00" default string.
      if (!(parseFloat(this.form.amount) > 0)) {
        this.$toast.error("Amount is required.");
        return;
      }

      this.showLoading();
      let expense_date_new = moment(this.form.expense_date)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.form.image = [];
      let form_data_edit = new FormData();

      this.image_list_edit.forEach((image) => {
        form_data_edit.append("image", image.file);
      });

      form_data_edit.append("expense_id", this.form.expense_id);
      // form_data_edit.append("expense_no", this.form.expense_no);
      form_data_edit.append("amount", parseFloat(this.form.amount).toFixed(2));
      form_data_edit.append("payment_type", this.form.payment_type);
      form_data_edit.append("expense_date", expense_date_new);
      form_data_edit.append("category_id", this.form.category_id);
      form_data_edit.append("vendor", this.form.vendor);
      form_data_edit.append("notes", this.form.notes);
      form_data_edit.append("currency_id", this.form.currency_id);
      form_data_edit.append("is_image", this.form.is_image);

      this.$store
        .dispatch("expenses/updateExpenses", form_data_edit)
        .then((res) => {
          if (res.status == 1) {
            this.$toast.success("Update data Successful.");
            this.$router.push({ name: "list-expenses" });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    async fetchCurrency() {
      this.currency = await this.axios
        .get(CURRENCY_LIST)
        .then(function (res) {
          return res.data.response;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async expenseCategory() {
      this.showLoading();
      this.expense_category = await this.$store
        .dispatch("expenses/getAllExpenseCategory")
        .then((res) => {
          // console.log(res);
          if (res.status == 1) {
            return res.response;
            // this.$router.push({ name: 'user-dashboard' });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    async fetchPaymentMethod() {
      this.showLoading();
      this.payment_method = await this.$store
        .dispatch("expenses/getPaymentOptions")
        .then((res) => {
          // console.log(res);
          if (res.status == 1) {
            return res.response;
            // this.$router.push({ name: 'user-dashboard' });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    async onFileChange(e) {
      const files = Array.from(e.target.files);

      const resizedFiles = await Promise.all(
        files.map((file) => this.resizeImage(file, 512 * 1024))
      );

      const previews = await Promise.all(
        resizedFiles.map((file) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (ev) => resolve({ file, preview: ev.target.result });
            reader.readAsDataURL(file);
          });
        })
      );

      this.image_list_edit = previews.slice(0, 1);

      if (this.image_list_edit.length > 0) {
        this.image_count = this.image_list_edit.length;
        this.form.is_image = "Y";
      }
    },
    removeNewImage(index) {
      this.image_list_edit.splice(index, 1);
      this.image_count = this.image_list_edit.length;
      if (this.image_list_edit.length === 0) {
        this.form.is_image = "N";
      }
    },

    resizeImage(file, maxSize) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
          img.src = e.target.result;
        };

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Scale image dimensions down if too large
          let width = img.width;
          let height = img.height;
          const maxDimension = 1024; // limit max side length (optional)

          if (width > height && width > maxDimension) {
            height *= maxDimension / width;
            width = maxDimension;
          } else if (height > maxDimension) {
            width *= maxDimension / height;
            height = maxDimension;
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          let quality = 0.9;

          const attemptCompression = () => {
            canvas.toBlob(
              (blob) => {
                if (blob.size > maxSize && quality > 0.1) {
                  quality -= 0.1;
                  attemptCompression(); // retry with lower quality
                } else {
                  const resizedFile = new File([blob], file.name, {
                    type: blob.type,
                    lastModified: Date.now(),
                  });
                  resolve(resizedFile);
                }
              },
              "image/jpeg", // force JPEG for compression
              quality
            );
          };

          attemptCompression();
        };

        img.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    editDataPopulate(id) {
      this.$store
        .dispatch("expenses/getExpenseListById", { expenseId: id })
        .then((res) => {
          if (res.data.status == 1) {
            let single_expense = res.data.response;
            this.form.expense_id = id;
            this.form.expense_no = single_expense.expense_no;
            this.form.category_id = parseInt(single_expense.category_id);
            this.form.vendor = single_expense.vendor;

            this.form.expense_date = single_expense.expense_date;
            this.form.payment_type = single_expense.payment_type;
            this.form.notes = single_expense.notes;
            this.form.currency_id = single_expense.currency_id;

            this.form.amount = parseFloat(
              this.removeTrailingZeros(single_expense.amount)
            ).toFixed(2);

            // const parsed = JSON.parse(single_expense.url);
            if (single_expense.url !== "N/A" && single_expense.url !== null) {
              this.image_list = single_expense.url;
              this.image_list_names = single_expense.file_name;
            }

            setTimeout(() => {
              this.changeCurrency();
            }, 1000);
          } else {
            throw new Error(res);
          }
          this.hideLoading();
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    removeTrailingZeros(number) {
      // Convert the number to a string
      var numberString = number.toString();

      // Use a regular expression to remove trailing zeros
      var trimmedString = numberString.replace(/\.?0+$/, "");

      // Convert the string back to a number
      var result = parseFloat(trimmedString);

      return result;
    },
    deleteAttachment(image_name) {
      let form_data = new FormData();

      form_data.append("expense_no", this.form.expense_no);
      form_data.append("filename", image_name);
      this.$store
        .dispatch("expenses/deleteExpensesAttachment", form_data)
        .then((res) => {
          if (res.statusCode === 200) {
            this.$toast.success(res.message[0] || "Delete attachment Successful.");
            window.location.reload();
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    changeCurrency() {
      this.currency_symbol = this.currency.find(
        (currency) => currency.id == this.form.currency_id
      ).symbol;
    },
  },
};
</script>

<style scoped>
.image-container {
  position: relative;
}

.topright-image {
  box-sizing: content-box;
  position: absolute;
  top: 0.5em;
  right: -1.5em;
  line-height: 1;
}

.image-expense {
  width: 100%;
  height: auto;
}

.el-carousel {
  border: 2px solid #ccc;
  padding: 0;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

.el-carousel__item {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.preview {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.attachment-row {
  margin-top: 3.5rem;
}

.action-buttons-row {
  margin-top: 5.5rem;
}
</style>

